import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import './Message_Renderer.scss';
import { ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, formatTimestamp } from '@nu-art/ts-common';
import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { ModuleFE_User } from '../../../_entity.js';
import { MessageTools } from '@nu-art/ts-messaging-shared';
import { ModuleFE_Message } from '@nu-art/ts-messaging-frontend';
export class Message_Renderer extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        const message = ModuleFE_Message.cache.unique(nextProps.messageId);
        if (!message)
            throw new BadImplementationException(`Couldn't find message with id: ${nextProps.messageId}`);
        state.message = message;
        return state;
    }
    renderMessageContent(message) {
        if (MessageTools.isText(message))
            return this.renderTextMessage(message);
        return _jsxs("div", { children: ["Unsupported message type: ", this.state.message.type] });
    }
    renderTextMessage(message) {
        return _jsx("div", { className: 'message-text', children: message.text });
    }
    render() {
        if (!this.state.message)
            return;
        const account = ModuleFE_Account.cache.unique(this.state.message._auditorId);
        let name;
        if (account) {
            const user = ModuleFE_User.cache.unique(account._id);
            if (user && user.firstName)
                name = `${user.firstName}${user.surname ? ` ${user.surname}` : ``}`;
            else
                name = `${account.email}`;
        }
        else {
            name = `${this.state.message._auditorId}(deleted)`;
        }
        const dateTimeFormat = formatTimestamp('MM/D/YY HH:mm', this.state.message.__created);
        return _jsxs(LL_V_L, { className: 'message-container', children: [_jsxs(LL_H_C, { className: 'message-header', children: [_jsx("div", { className: 'sender-name', children: name }), _jsx("div", { className: 'date-format', children: dateTimeFormat })] }), this.renderMessageContent(this.state.message)] });
    }
}
//# sourceMappingURL=Message_Renderer.js.map